// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z5pC","textarea":"styles_textarea__2yaH1"};